/**
 * Created by huangzhangshu on 2018/8/1
 */
import React, { Component } from 'react';

import PerfectScrollbar from 'perfect-scrollbar';

export interface ScrollProps {
  marginTop?: number;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export interface ScrollState {
  id: string;
  childId: string;
  type: string;
}

export default class Scroll extends Component<ScrollProps, ScrollState> {

  ps: PerfectScrollbar | undefined = undefined;

  constructor(props: any) {
    super(props);
    this.state = {
      id: props.id || `scroll-${new Date().getTime()}`,
      childId: `scroll-children-${new Date().getTime()}`,
      type: props.type || 'div',
    };
  }

  componentDidMount() {
    const { marginTop } = this.props;
    const { id, type } = this.state;
    let container;
    const options = {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20
    }
    if (type === 'menu') {
      container = $(`#${id} .ant-menu`)[0];
      this.ps = new PerfectScrollbar(container, options);
      if (marginTop) {
        const htmlElement = document.getElementsByClassName('ps__rail-y')[0] as HTMLElement;
        htmlElement.style.marginTop = String(marginTop);
      }
    } else if (type === 'table') {
      container = $(`#${id} .ant-table-body`)[0];
      this.ps = new PerfectScrollbar(container, options);
    } else if (type === 'content') {
      container = $(`.ant-layout-content #${id}`)[0];
      this.ps = new PerfectScrollbar(container, options);
    } else {
      container = document.getElementById(id) as HTMLElement;
      this.ps = new PerfectScrollbar(container);
    }
    if (container) {
      container.style.overflow = 'hidden';
    }
  }

  componentDidUpdate() {
    const { ps } = this;
    if (ps) ps.update();
  }

  componentWillUnmount() {
    const { ps } = this;
    if (ps) ps.destroy();
    this.ps = undefined;
  }

  render() {
    const { children, className = '', style = {} } = this.props;
    const { id } = this.state;
    return (
      <div id={id} style={{ ...style }} className={`${className}`}>
        {children}
      </div>
    );
  }
}
